const ConfirmPasswordIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path fill="#none" d="M10 14a1.49 1.49 0 00-1 2.61V18a1 1 0 102 0v-1.39A1.49 1.49 0 0010 14zm5-4V8A5 5 0 005 8v2a3 3 0 00-3 3v7a3 3 0 003 3h10a3 3 0 003-3v-7a3 3 0 00-3-3zM7 8a3 3 0 116 0v2H7V8zm9 12a1 1 0 01-1 1H5a1 1 0 01-1-1v-7a1 1 0 011-1h10a1 1 0 011 1v7z" />
      <path fill="#none" d="M17.828 21H19a3 3 0 003-3v-7a3 3 0 00-3-3V6a5 5 0 00-9-3 5 5 0 012.273.547A3 3 0 0117 6v2h-2v2h4a1 1 0 011 1v7a1 1 0 01-1 1h-1v1a3 3 0 01-.172 1z" />
    </svg>
  );
};

export default ConfirmPasswordIcon;